import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export function DeleteConfirmModal({ open, onClose, onConfirm, title, description, count }) {
  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent data-testid="delete-confirm-modal">
        <AlertDialogHeader>
          <AlertDialogTitle style={{ fontFamily: 'Manrope, sans-serif' }}>
            {title || 'Silmek istediğinizden emin misiniz?'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description || (
              count > 1 
                ? `Seçili ${count} öğe kalıcı olarak silinecektir. Bu işlem geri alınamaz.`
                : 'Bu öğe kalıcı olarak silinecektir. Bu işlem geri alınamaz.'
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-cancel-btn">İptal</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-500 hover:bg-red-600"
            data-testid="delete-confirm-btn"
          >
            Sil
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
